import { Amplify } from "aws-amplify";
import type { Config } from "../config";

/**
 * Nur die Anmeldung läuft über Amplify.
 *
 * Der Vorgänger nutzte zusätzlich Amplifys Storage-Modul, um mit
 * AWS-Anmeldedaten aus einem Identity Pool direkt nach S3 zu schreiben. Das
 * entfällt: Uploads laufen über vorsignierte URLs, die die API ausstellt — der
 * Browser bekommt überhaupt keine AWS-Anmeldedaten mehr.
 */
export function konfiguriereAuth(config: Config): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
      },
    },
  });
}
